// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"GroupDetails_tabContainer_1kYhE","inheritHeight":"GroupDetails_inheritHeight_38qUq"};